import { exampleUser, User } from '../user';

export type AdCreativeReviewOrigin = 'internal' | 'external';

export interface AdCreativeReview {
  id: number;
  creativeID: number;
  user: User;
  type: AdCreativeReviewOrigin;
  approved: boolean;
  createdAt: number;
  updatedAt: number;
}

export const exampleAdCreativeReview: AdCreativeReview = {
  id: 1,
  creativeID: 1,
  user: exampleUser,
  type: 'internal',
  approved: true,
  createdAt: 0,
  updatedAt: 0,
};

export interface AdCreativeReviewDTO {
  approved: boolean;
}
